import React, { useContext } from 'react';
import { GameDocumentContext } from '../../contexts/game-document';
import { ManualScoring } from '../../types/manual-scoring';
import { GetTaskById, GetTaskTitle } from '../../utils/game-document/assets';
import { GetTaskContentById } from '../../utils/game-document/assets/task-contents';

export const dateFormat = (dateUTC: string) => {
  const date = new Date(dateUTC);

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const month = date.getMonth() + 1;
  const day = date.getDate();

  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');

  const formattedMonth = String(month).padStart(2, '0');
  const formattedDay = String(day).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes} ${formattedMonth}/${formattedDay}`;
};

interface ListProps {
  listData?: ManualScoring[];
  selectedId: number;
  onClick?: (item: ManualScoring) => void;
}

export const FacilitatorScoringList = ({
  listData,
  selectedId,
  onClick = () => {}
}: ListProps) => {
  const [gameDocumentState] = useContext(GameDocumentContext);

  const taskList = (gameDocumentState.gameDocument?.assets.tasks ?? []).map(
    (t) => t.id
  );

  const isOnDemandTask = (id: string) => !taskList.includes(id);

  return (
    <div className="list-group w-100 ">
      {listData?.map((item) => (
        <div
          key={`${item.playerCode}-${item.formId}-${item.id}`}
          className={'cursor-pointer'}
          onClick={() => onClick(item)}
          style={{
            backgroundColor: item.id === selectedId ? '#f8fcfe' : 'white'
          }}>
          <div
            className={'row m-0'}
            style={{
              padding: '15px 20px'
            }}>
            <div className={'col-8 p-0'}>
              <div className={'d-flex flex-column'}>
                <small className={'text-dark'}>{item?.playerName}</small>
                <small className={'text-dark fw-bold'}>
                  {GetTaskTitle(
                    gameDocumentState?.gameDocument,
                    item.taskId ?? ''
                  )}
                </small>
              </div>
            </div>

            <div className={'col-4 p-0'}>
              <div
                className={
                  'd-flex w-100 flex-column h-100 align-items-end text-end text-secondary'
                }>
                <small>{dateFormat(item.SubmittedDateUtc as string)}</small>
                {isOnDemandTask(item.taskId ?? '') && (
                  <small className={'text-success'}>On-Demand Task</small>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
